<div class="dialog__body">
  <p class="dialog__description">求人種別を選択してください</p>
  <div class="dialog__radio-group">
    <label class="dialog__radio-item" *ngFor="let option of jobAzCheckCategoryOptions">
      <input
        type="radio"
        name="jobCheckType"
        [value]="option.value"
        [checked]="selectedJobCategory === option.value"
        (change)="selectedJobCategory = option.value"
      />
      <span>{{ option.label }}</span>
    </label>
  </div>
</div>
